import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'
import Multiselect from 'vue-multiselect'
import VueElementLoading from 'vue-element-loading';

export default {
	name: 'creategroup',
	components: {
		Paginate,
		BasicSelect,
		VueElementLoading,
		Multiselect
	},
	data: function() {
		return {
			HubList: [],
			groupList: [],
			connectionList: [],
			cHubid: '',
			Hubid: '',
			Hubname: '',
			GroupSearchFlag: false,
			groupid: 0,

			pageno: 0,
			pageCount: 0,
			pageLimit: 10,
			resultCount: 0,
			totalRows: 0,

			isLoading: false,
			showModal: false,
			popUpname: '',
			hubLoading: '',

			hubObjData: {
				value: "",
				text: ""
			},
		}
	},

	created: function() {},
	computed: {},

	mounted() {

		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)

		this.getCityList();

	},
	methods: {

		selectedCity(hubData) {
			//console.log(cityData);
			this.hubObjData = hubData
			this.Hubid = hubData.value;
			this.Hubname = hubData.text;
		},

		getGroupList() {
			if (this.Hubid == undefined) {
				return false
			}
			if (this.Hubid != "") {
				// var hub_array = this.Hubid.split("-");
				// var hubid = hub_array[0];
				// var hubname = hub_array[1];
				this.groupList = [];
				this.input = ({})
				this.totalRows = 0
				axios({
						method: 'GET',
					//'url': apiUrl.api_url_hubops + 'getLocationMatchedGroups?offset=' + this.pageno + '&limit=' + this.pageLimit + '&DestinationHubId=' + this.Hubid,
						'url': apiUrl.api_url_hubops + 'groups/by-destination-hub?destinationHubId=' + this.Hubid
							+ '&profile=detail&offset=' + this.pageno + '&limit=' + this.pageLimit + '&includeTotalCount=true',
						'data': {},
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
						}
					})
					.then(result => {
						if (result.data.ResultCode == 100) {
							this.groupList = result.data.ResponseData;
							this.resultCount = result.data.ResponseData.length;

							this.totalRows = result.data.TotalCount
							if (this.totalRows <= this.pageLimit) {
								this.pageCount = 1
							} else {
								this.pageCount = Math.ceil(this.totalRows / this.pageLimit);
							}
						} else {
							this.resultCount = 0;
							//this.$alertify.error(result.data.ReturnMessage)
							this.$alert(result.data.ReturnMessage, "", "error");
						}

					}, error => {
						console.error(error)
					})
			} else {
				return false;
			}

		},

		getGroupConnections(data) {
			this.groupid = data.groupid;
			this.popUpname = data.groupid + ' ' + ' ' + data.groupname + ' ' + data.routemode

			this.input = ({})

			axios({
					method: 'GET',
					// HUB-8335: replaces getConnectionsByGroup (summary, includes inactive mappings)
					'url': apiUrl.api_url_hubops + 'groups/' + this.groupid + '/connection-mappings?fields=summary&activeOnly=false',
					'data': {},
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.showModal = true;
						this.connectionList = result.data.ResponseData;
					} else {
						//this.$alertify.error(result.data.ReturnMessage)
						this.$alert(result.data.ReturnMessage, "", "error");
						return false;
					}
				})
		},

		closeModal() {
			this.showModal = false;
			$(document.body).removeClass("modal-open");
			$(".modal-backdrop").remove();
		},

		//to get City list
		getCityList() {
			this.hubLoading = 'Loading Hub...'
			//var userToken = window.localStorage.getItem('userToken')
			//var myStr = userToken.replace(/"/g, '');
			var i = 0;
			this.resultCount = 0;
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					var hubList = result.data.ResponseData
					for (i = 0; i < hubList.length; i++) {
						this.HubList.push({
							value: hubList[i].HubID,
							text: hubList[i].HubName + ' (' + hubList[i].HubID + ')'
						})
					}
				}, error => {
					console.error(error)
				})
		},

		resetForm() {
			this.Hubid = '';
			this.cHubid = '';
			this.hubObjData = {
				value: "",
				text: ""
			};
			this.$validator.reset();
			this.errors.clear();
		},
		//to get pagination
		getPaginationData(pageNum) {
			this.pageno = (pageNum - 1)
			this.getGroupList();
		},

		//validate all form fields on onsubmit()
		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid')
			}).catch(() => {
				console.log('errors exist')
			});
		},

	}
}


// WEBPACK FOOTER //
// ./src/views/components/group/locationsearch/locationsearch_component.js